module.exports = __webpack_public_path__ + "static/media/dinersclub-icon.3db39ea7.svg";